import { isCoordinateLocation } from '@ngsos/portal-core/realtime';
import type { PortalCall } from '@/signalr/contracts';
import { callerMarker } from '@/features/shared/map/markers';
import type { MapMarker } from '@/features/shared/map/markers';

export function callNotificationMarkers(calls: readonly PortalCall[]): MapMarker[] {
  return calls.flatMap((call) => {
    const location = call.lastLocation;
    if (location === null || !isCoordinateLocation(location)) {
      return [];
    }

    return [callerMarker(call.id, [location.latitude, location.longitude])];
  });
}
